import { useEffect, useState } from "react";
import useAxiosPost from "../../hooks/useAxiosPost";
import { Col, Row } from "antd";
import MeshBillButton from "../Items/Button/Index";
import { FiPlusCircle } from "react-icons/fi";
import { ButtonProps } from "../../helpers/constants";
import CreateCompanyModalComponent from "../Modals/CreateNewCompanyModal";
import ViewCompaniesTable from "../Tables/ViewCompaniesTable";
// const ViewCompaniesTable = lazy(() => import("../Tables/ViewCompaniesTable"));
// const CreateCompanyModalComponent = lazy(
//   () => import("../Modals/CreateNewCompanyModal")
// );
const ViewAllCompaniesComponent = () => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [showCreate, setShowCreate] = useState<boolean>(false);
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ResponseProp>("superAdmin/getAllCompanies");

  useEffect(() => {
    postApiData({});
  }, []);
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      console.log({ data });
      setCompanies(data || []);
    }
  }, [apiResponse]);
  const handleClose = (isReload: boolean) => {
    setShowCreate(false);
    if (isReload === true) {
      postApiData({});
    }
  };

  return (
    <>
      {showCreate === true && (
        <CreateCompanyModalComponent
          show={showCreate}
          handleClose={handleClose}
        />
      )}
      <Row className="full-width-row">
        <Col
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "20px",
          }}
          lg={24}
          xl={24}
          xxl={24}
          md={12}
          sm={24}
          span={24}
        >
          <MeshBillButton
            backgroundColor={ButtonProps.background.STANDARD}
            height={ButtonProps.height.STANDARD}
            width={ButtonProps.width.STANDARD}
            textColor={ButtonProps.color.STANDARD}
            onClick={() => {
              setShowCreate(true);
            }}
            text="Create Company"
            icon={<FiPlusCircle />}
          />
        </Col>
        <Col span={24}>
          <ViewCompaniesTable isLoading={apiLoading} companies={companies} />
        </Col>
      </Row>
    </>
  );
};
export default ViewAllCompaniesComponent;
